import { render, staticRenderFns } from "./ContractViewTimelineItemAddendum.vue?vue&type=template&id=c5c9ad68&scoped=true&"
import script from "./ContractViewTimelineItemAddendum.vue?vue&type=script&lang=js&"
export * from "./ContractViewTimelineItemAddendum.vue?vue&type=script&lang=js&"
import style0 from "./ContractViewTimelineItemAddendum.vue?vue&type=style&index=0&id=c5c9ad68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c9ad68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VIcon,
  VLayout,
  VTimelineItem,
  VTooltip,
})
